// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Avatar-imgBackground-lZO88 {
	background-color: var(--secondary-gray-bg);
}

.Avatar-defaultIcon-MeQLP {
	border-radius: 50%;
	display: -webkit-inline-box;
	display: -ms-inline-flexbox;
	display: inline-flex;
	-webkit-box-align: center;
	    -ms-flex-align: center;
	        align-items: center;
	-webkit-box-pack: center;
	    -ms-flex-pack: center;
	        justify-content: center;
	width: 50px;
	height: 48px;
}

.Avatar-defaultIconTransparent-mSzLG {
	border-radius: 50%;
	display: -webkit-inline-box;
	display: -ms-inline-flexbox;
	display: inline-flex;
	-webkit-box-align: center;
	    -ms-flex-align: center;
	        align-items: center;
	-webkit-box-pack: center;
	    -ms-flex-pack: center;
	        justify-content: center;
	width: 50px;
	height: 48px;
	background: transparent;
}`, "",{"version":3,"sources":["webpack://./src/components/Avatar/Avatar.css"],"names":[],"mappings":"AAAA;CACC,0CAA0C;AAC3C;;AAEA;CACC,kBAAkB;CAClB,2BAAoB;CAApB,2BAAoB;CAApB,oBAAoB;CACpB,yBAAmB;KAAnB,sBAAmB;SAAnB,mBAAmB;CACnB,wBAAuB;KAAvB,qBAAuB;SAAvB,uBAAuB;CACvB,WAAW;CACX,YAAY;AACb;;AAEA;CACC,kBAAkB;CAClB,2BAAoB;CAApB,2BAAoB;CAApB,oBAAoB;CACpB,yBAAmB;KAAnB,sBAAmB;SAAnB,mBAAmB;CACnB,wBAAuB;KAAvB,qBAAuB;SAAvB,uBAAuB;CACvB,WAAW;CACX,YAAY;CACZ,uBAAuB;AACxB","sourcesContent":[".imgBackground {\n\tbackground-color: var(--secondary-gray-bg);\n}\n\n.defaultIcon {\n\tborder-radius: 50%;\n\tdisplay: inline-flex;\n\talign-items: center;\n\tjustify-content: center;\n\twidth: 50px;\n\theight: 48px;\n}\n\n.defaultIconTransparent {\n\tborder-radius: 50%;\n\tdisplay: inline-flex;\n\talign-items: center;\n\tjustify-content: center;\n\twidth: 50px;\n\theight: 48px;\n\tbackground: transparent;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"imgBackground": `Avatar-imgBackground-lZO88`,
	"defaultIcon": `Avatar-defaultIcon-MeQLP`,
	"defaultIconTransparent": `Avatar-defaultIconTransparent-mSzLG`
};
module.exports = ___CSS_LOADER_EXPORT___;
